import './App.css';
import FoodTruckLanding from './FoodTruckLanding';

function App() {
  return (
    <div className="App">
      <FoodTruckLanding />
    </div>
  );
}

export default App;